import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from 'antd';
import { FaCheck, FaRegCopy } from 'react-icons/fa';
import { strings } from '@constants/strings.js';
import ViewIcon from '@common-web/show-phone-button/ViewIcon.jsx';
import Skeleton from '@common-web/skeleton/index.jsx';
import { viewPhoneNumberApi } from '@apis/cp/sellers.js';
import { Dropdown, Toast } from '@common-web/index.js';
import { formatPhoneNo } from '@utils/utils.js';
import { useSelector } from 'react-redux';

const ShowPhoneButton = (props) => {
  const { ctaText = strings.show_phone_number, viewIconClassName = '', storeId } = props;
  const dropdownContentRef = useRef();
  const { t } = useTranslation();
  const { tenant } = useSelector((state) => state.tenantData);

  const [showPhoneNumber, setShowPhoneNumber] = useState(false);
  const [loading, setLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showIcon, setShowIcon] = useState(null);

  const handleShowPhoneNumberClick = async () => {
    if (!storeId) {
      Toast.error(t(strings.something_went_wrong));
      return;
    }
    setShowPhoneNumber(!showPhoneNumber);
    setLoading(true);
    try {
      const res = await viewPhoneNumberApi(storeId);
      if (res?.success) {
        setPhoneNumber(res?.mobile);
      }
    } catch (error) {
      Toast.error(t(strings.something_went_wrong));
      setShowPhoneNumber(false);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseDropdown = () => {
    setShowPhoneNumber(false);
  };

  return (
    <Dropdown
      value={
        <div>
          <ViewIcon ctaText={ctaText} className={viewIconClassName} />
        </div>
      }
      items={[
        {
          key: 1,
          label: loading ? (
            <Flex vertical gap={2}>
              <div>Phone Number</div>
              <Skeleton height={15} />
            </Flex>
          ) : (
            <div onClick={(e) => e.stopPropagation()}>
              <Flex vertical gap={2} ref={dropdownContentRef}>
                <div className="fw-600">Phone Number</div>
                <Flex align="center" justify="space-between" gap={'small'}>
                  {formatPhoneNo(phoneNumber, tenant?.name)}
                  <div
                    onClick={() => {
                      navigator.clipboard.writeText(phoneNumber);
                      setShowIcon(phoneNumber);
                      setTimeout(() => {
                        setShowIcon(null);
                        setShowPhoneNumber(false);
                      }, 2000);
                    }}
                  >
                    {showIcon === phoneNumber ? (
                      <FaCheck color={'var(--ant-color-primary)'} />
                    ) : (
                      <FaRegCopy color={'var(--ant-color-primary)'} />
                    )}
                  </div>
                </Flex>
              </Flex>
            </div>
          ),
        },
      ]}
      trigger={['hover']}
      open={showPhoneNumber}
      setOpen={setShowPhoneNumber}
      onClick={() => {
        if (!showPhoneNumber) {
          handleShowPhoneNumberClick();
        } else {
          setShowPhoneNumber(!showPhoneNumber);
        }
      }}
      onVisibleChange={(visible) => {
        if (!visible && dropdownContentRef.current) {
          if (!dropdownContentRef.current.contains(document.activeElement)) {
            handleCloseDropdown();
          }
        }
      }}
      placement="bottomLeft"
      arrow
      disableHover
      overlayStyle={{ zIndex: 1200 }}
    />
  );
};

export { ShowPhoneButton };
